// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Button from 'ant-design-vue/lib/button';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import axios from 'axios'
import VueResource from 'vue-resource'
import VuevideoPlayer from 'vue-video-player';
import VueCookies from "vue-cookies";
import 'video.js/dist/video-js.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css';
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.prototype.$wow = wow
Vue.use(animated);

Vue.use(AOS);
Vue.use(ElementUI);

Vue.use(VuevideoPlayer);

Vue.prototype.$axios = axios;


Vue.component(Button.name, Button);

Vue.config.productionTip = false

Vue.use(Antd)


Vue.use(VueResource)
Vue.use(VueCookies);

router.afterEach((to,from,next) => {
	document.body.scrollTop =0;
	document.documentElement.scrollTop = 0;
});



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'islogin') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}



// WEBPACK FOOTER //
// ./src/main.js